export default __webpack_public_path__ + "static/media/en.d02f15ba.svg";